import axios from 'axios';

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const API_URL = getApiUrl('/Commitment/commitments/');

// Create an Axios instance with default headers
const apiClient = axios.create({
  baseURL: API_URL,
});

// Add an interceptor to include the access token in the headers
apiClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export const fetchCommitments = () => apiClient.get('/');
export const fetchCommitment = (id) => apiClient.get(`${id}/`);
export const createCommitment = (data) => apiClient.post('create/', data);
export const updateCommitment = (id, data) => apiClient.put(`update/${id}/`, data);
export const deleteCommitment = (id) => apiClient.delete(`delete/${id}/`);
export const filterCommitments = (filters) => apiClient.get('filtercommitments/', { params: filters });